import { __spreadArray } from 'tslib';
import React__default from 'react';
import { fetcherModeAtom, FetcherMode, useBounceSearch, MetaField } from '@keepeek/commons';
import { useRecoilValue } from 'recoil';
import { ElementMetaField } from '../../../ElementMetaField/index.js';

var findMediaField = function (fieldId, media) {
    var _a;
    if (fieldId === MetaField.TITLE) {
        return media.title;
    }
    else {
        return (_a = media.fields) === null || _a === void 0 ? void 0 : _a.find(function (f) { return f.id === fieldId; });
    }
};
var ElementsMetaField = function (_a) {
    var media = _a.media, fields = _a.fields, dataViewKey = _a.dataViewKey, KIcon = _a.KIcon;
    var fetcherMode = useRecoilValue(fetcherModeAtom);
    var isShare = fetcherMode === FetcherMode.SHARE;
    var handleBounceClick = useBounceSearch(dataViewKey);
    var fieldIdsToDisplay = fields.length > 0 ? __spreadArray([], fields, true) : [MetaField.TITLE];
    return (React__default.createElement(React__default.Fragment, null, fieldIdsToDisplay.map(function (fieldId) {
        var metaField = findMediaField(fieldId, media);
        if (metaField) {
            return (React__default.createElement(ElementMetaField, { key: metaField.id, field: metaField, summaryDisplay: true, onClick: !isShare
                    ? function (value) {
                        handleBounceClick(metaField, value);
                    }
                    : undefined, KIcon: KIcon }));
        }
        return null;
    })));
};

export { ElementsMetaField, ElementsMetaField as default };
//# sourceMappingURL=index.js.map
